<template>
  <div id="staff-list-premium-dashboard"
    style="background-color: #f4f7fa !important; min-height: 100vh !important; font-family: 'Inter', sans-serif !important;">
    <!-- Premium Header Banner (JCI Brand) -->
    <v-container fluid class="pa-0 mb-8">
      <v-card class="premium-header-card pa-8 overflow-hidden" flat
        style="border-radius: 0 0 50px 50px !important; background: linear-gradient(135deg, #3A67B1 0%, #0097D7 100%) !important; min-height: 180px !important; position: relative !important;">
        <!-- Animated Background Bubbles (LDMT Style) -->
        <div class="header-bubbles">
          <div class="bubble b-1"></div>
          <div class="bubble b-2"></div>
          <div class="bubble b-3"></div>
          <div class="bubble b-4"></div>
          <div class="bubble b-5"></div>
        </div>

        <v-row align="center" style="position: relative; z-index: 2;">
          <v-col cols="12" md="8">
            <div class="d-flex align-center mb-2">
              <v-icon large class="mr-3" style="color: #EDBE38 !important;">mdi-account-group-outline</v-icon>
              <span class="text-overline font-weight-bold"
                style="letter-spacing: 3px !important; color: #EDBE38 !important;">
                JCI INDIA NHQ
              </span>
            </div>
            <h1 class="text-h3 font-weight-black mb-2 white--text">
              Staff Directory
            </h1>
            <p class="text-h6 font-weight-medium white--text opacity-80">
              Strategic personnel management and priority organization dashboard.
            </p>
          </v-col>
          <v-col cols="12" md="4" class="text-right align-self-center">
            <v-btn fab color="rgba(255,255,255,0.2)" class="elevation-12 mr-4 action-btn-glow"
              @click.prevent="addRecordPrompt = true" x-large>
              <v-icon color="white" size="40">mdi-account-plus</v-icon>
            </v-btn>
            <v-btn fab color="rgba(255,255,255,0.2)" class="elevation-12 action-btn-glow" @click="refreshPageData"
              :loading="LoadingFlag" x-large>
              <v-icon color="white" size="40">mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <br><br>

    <v-container class="mt-n16 pb-12" style="position: relative; z-index: 3;">
      <!-- Ultra-Transparent Glassmorphism Note -->
      <v-card class="pa-6 mb-10 shadow-premium overflow-hidden true-glass-note"
        style="border-radius: 24px !important; background: rgba(58, 103, 177, 0.08) !important; backdrop-filter: blur(12px) !important; -webkit-backdrop-filter: blur(12px) !important; border: 1px solid rgba(58, 103, 177, 0.2) !important; position: relative !important;">
        <v-row align="center">
          <v-col cols="12" md="7">
            <div class="d-flex align-center mb-3">
              <v-avatar color="rgba(58, 103, 177, 0.15)" size="48" class="mr-3 elevation-2">
                <v-icon size="24" color="#3A67B1">mdi-account-group</v-icon>
              </v-avatar>
              <div class="text-overline font-weight-black"
                style="letter-spacing: 2px !important; color: #3A67B1 !important;">PERSONNEL SUMMARY</div>
            </div>
            <h2 class="text-h4 font-weight-black mb-3"
              style="letter-spacing: -0.5px !important; color: #0A0F29 !important;">
              {{ filteredRows.length }} Staff Personnel <span
                class="text-h5 grey--text text--darken-2 font-weight-medium">Records</span>
            </h2>
            <div class="d-flex align-center">
              <v-chip color="rgba(58, 103, 177, 0.1)" class="mr-3 px-4 font-weight-bold"
                style="color: #3A67B1 !important; border: 1px solid rgba(58, 103, 177, 0.2) !important;" small>
                <v-icon left size="16">mdi-shield-check</v-icon> SYNCED
              </v-chip>
              <v-chip color="#EDBE38" class="black--text px-4 font-weight-black elevation-2" small>
                <v-icon left color="black" size="16">mdi-sync</v-icon> LIVE
              </v-chip>
            </div>
          </v-col>
          <v-col cols="12" md="5" class="text-right d-flex flex-column align-end">
            <v-sheet class="pa-4 rounded-xl d-flex align-center overflow-hidden"
              style="background: rgba(255, 255, 255, 0.4) !important; border: 1px solid rgba(58, 103, 177, 0.1) !important; max-width: 340px; backdrop-filter: blur(5px);">
              <v-icon color="#3A67B1" class="mr-3" size="28">mdi-cursor-move</v-icon>
              <div class="text-left">
                <div class="text-subtitle-2 font-weight-black" style="color: #3A67B1 !important;">Reorder Sequence</div>
                <div class="text-caption grey--text text--darken-3 font-weight-bold" style="line-height: 1.2;">
                  Drag rows to update priority.
                </div>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-card>

      <!-- Glassmorphism Search Card -->
      <v-card class="pa-6 mb-12 elevation-12 shadow-premium glass-effect"
        style="border-radius: 24px !important; background: rgba(255, 255, 255, 0.9) !important; border: 1px solid rgba(58, 103, 177, 0.1) !important;">
        <v-row align="center">
          <v-col cols="12" md="8">
            <div class="d-flex align-center mb-2">
              <v-icon small style="color: #3A67B1 !important;" class="mr-2">mdi-magnify</v-icon>
              <span class="text-subtitle-2 font-weight-bold"
                style="color: #414042 !important; letter-spacing: 1px;">DIRECTORY SEARCH</span>
            </div>
            <v-text-field v-model="search" placeholder="Search by name, designation, or ID..." outlined rounded dense
              hide-details class="premium-search-input" prepend-inner-icon="mdi-account-search-outline"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="text-right">
            <v-sheet class="pa-3 px-6 d-inline-flex align-center" rounded="pill"
              style="background: #f0f7ff !important; border: 1px solid #dbeafe !important;">
              <v-icon small color="#3A67B1" class="mr-2">mdi-account-check</v-icon>
              <span class="text-subtitle-2 font-weight-black" style="color: #3A67B1 !important;">
                TOTAL: {{ filteredRows.length }} PERSONNEL
              </span>
            </v-sheet>
          </v-col>
        </v-row>
      </v-card>

      <!-- Loading State -->
      <div v-if="LoadingFlag" class="d-flex flex-column align-center justify-center py-16 my-16">
        <v-progress-circular indeterminate color="#3A67B1" size="100" width="10"></v-progress-circular>
        <h3 class="mt-8 text-h5 font-weight-black text-uppercase"
          style="letter-spacing: 4px; color: #3A67B1 !important;">Synchronizing Data</h3>
      </div>

      <!-- Result Container -->
      <div v-else>
        <!-- Empty State -->
        <v-card v-if="ResultFlag && filteredRows.length == 0" class="pa-16 text-center shadow-premium" elevation="4"
          style="border-radius: 32px !important;">
          <v-icon size="120" color="grey lighten-3">mdi-account-off-outline</v-icon>
          <h2 class="text-h4 font-weight-black mt-8" style="color: #414042 !important;">No Personnel Found</h2>
          <p class="text-h6 grey--text font-weight-medium">Try adjusting your search filters or add a new member.</p>
          <v-btn style="background-color: #3A67B1 !important; color: white !important;" rounded x-large
            @click="search = ''" class="mt-6 px-12 elevation-8">
            <v-icon left>mdi-refresh</v-icon> Clear Filters
          </v-btn>
        </v-card>

        <!-- Premium List Grid -->
        <div class="staff-records-container">
          <draggable v-model="rows" handle=".drag-handle" animation="500" ghost-class="ghost-row"
            chosen-class="chosen-row" drag-class="drag-row" @end="onDragEnd">
            <transition-group type="transition" name="flip-list">
              <v-card v-for="(item, index) in filteredRows" :key="item.MemberId"
                class="staff-record-row-card pa-5 mb-6 shadow-premium hover-card-row"
                style="border-radius: 20px !important; border: 1px solid #edf2f7 !important; border-top: 10px solid #3A67B1 !important;">
                <v-row align="center" no-gutters>
                  <!-- Drag & Order -->
                  <v-col cols="auto" class="d-flex align-center mr-8">
                    <div class="drag-handle-container d-flex flex-column align-center">
                      <v-icon class="drag-handle" color="#3A67B1">mdi-cursor-move</v-icon>
                      <div class="text-h6 font-weight-black grey--text text--lighten-1 mt-1">#{{ index + 1 }}</div>
                    </div>
                  </v-col>

                  <!-- Profile & Basic Info -->
                  <v-col cols="12" md="4">
                    <div class="d-flex align-center">
                      <v-avatar size="80" class="mr-6 profile-ring elevation-8"
                        style="border: 4px solid #fff !important;">
                        <v-img :src="item.ProfilePic" alt="Profile"></v-img>
                      </v-avatar>
                      <div>
                        <div class="text-h5 font-weight-black" style="line-height: 1.1; color: #0A0F29 !important;">
                          {{ item.MemberName }}
                        </div>
                        <div class="text-subtitle-1 font-weight-bold d-flex align-center mt-2"
                          style="color: #414042 !important;">
                          <v-icon small class="mr-2" style="color: #0097D7 !important;">mdi-badge-account</v-icon>
                          {{ item.StaffDesignation || 'Strategic Personnel' }}
                        </div>
                        <v-chip small class="mt-3 font-weight-black px-4" color="#f1f5f9"
                          style="color: #3A67B1 !important;">
                          ID: {{ item.MembershipId }}
                        </v-chip>
                      </div>
                    </div>
                  </v-col>

                  <!-- Contact Details -->
                  <v-col cols="12" md="3" class="px-6">
                    <v-list dense class="pa-0 transparent">
                      <v-list-item class="px-0 min-h-0 mb-2" v-if="item.MobileNo">
                        <v-list-item-avatar size="32" class="my-0 mr-4 elevation-2"
                          style="background: white !important;">
                          <v-icon size="16" color="#3A67B1">mdi-phone</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0">
                          <v-list-item-title class="text-subtitle-2 font-weight-black"
                            style="color: #414042 !important;">{{ item.MobileNo }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0 min-h-0" v-if="item.EmailId">
                        <v-list-item-avatar size="32" class="my-0 mr-4 elevation-2"
                          style="background: white !important;">
                          <v-icon size="16" color="#0097D7">mdi-email-outline</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0">
                          <v-list-item-title class="text-subtitle-2 font-weight-black"
                            style="color: #414042 !important;">{{ item.EmailId }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>

                  <!-- Status & Management -->
                  <v-col cols="12" md="2" class="text-center">
                    <div class="d-flex flex-column align-center">
                      <v-chip small :color="getActiveStatusColor(item.ActiveStatusTxt)" dark
                        class="mb-3 font-weight-black elevation-4 px-6"
                        style="min-width: 100px; text-transform: uppercase; letter-spacing: 1px;">
                        {{ item.ActiveStatusTxt }}
                      </v-chip>
                      <v-switch v-model="item.ActiveStatus" inset dense hide-details class="mt-0 premium-switch"
                        @click.stop="changeStatus(item)" :color="item.ActiveStatus ? '#56BDA3' : '#FF5252'"></v-switch>
                    </div>
                  </v-col>

                  <!-- Premium Actions -->
                  <v-col cols="12" md="2" class="text-right">
                    <div class="d-flex justify-end gap-3">
                      <!-- Edit Button -->
                      <v-tooltip bottom color="#56BDA3">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn fab small style="background: #56BDA3 !important; color: white !important;"
                            v-bind="attrs" v-on="on" class="action-btn-elevate elevation-6 mr-2"
                            @click.stop="openEditPrompt(item)">
                            <v-icon size="20">mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Edit Designation</span>
                      </v-tooltip>

                      <!-- Preview Button -->
                      <v-tooltip bottom color="#3A67B1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn fab small style="background: #3A67B1 !important; color: white !important;"
                            v-bind="attrs" v-on="on" class="action-btn-elevate elevation-6"
                            @click.stop="previewData(item)" v-if="item.ActiveStatus == 2">
                            <v-icon size="20">mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>Preview Profile</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </transition-group>
          </draggable>
        </div>
      </div>
    </v-container>

    <!-- Staff Create Popup -->
    <v-dialog v-model="addRecordPrompt" persistent max-width="850px" transition="dialog-bottom-transition">
      <staff-create pageDescription="Create Staff" :addRecordPrompt="addRecordPrompt"
        @hideAddRecordPrompt="hideAddRecordPrompt" v-if="addRecordPrompt"></staff-create>
    </v-dialog>

    <!-- Staff Edit Popup -->
    <v-dialog v-model="editRecordPrompt" persistent max-width="700px" transition="dialog-bottom-transition">
      <staff-edit pageDescription="Edit Staff" :editRecordPrompt="editRecordPrompt" :record="selectedRecord"
        @hideEditRecordPrompt="hideEditRecordPrompt" v-if="editRecordPrompt"></staff-edit>
    </v-dialog>

    <!-- Overlay Loader -->
    <v-overlay :value="reorderLoading" z-index="9999" opacity="0.6">
      <v-card class="pa-8 text-center rounded-xl elevation-24" light
        style="background: rgba(255, 255, 255, 0.95) !important; min-width: 300px;">
        <v-progress-circular indeterminate color="#3A67B1" size="80" width="8" class="mb-6"></v-progress-circular>
        <div class="text-h5 font-weight-black" style="color: #3A67B1 !important; letter-spacing: 2px;">SYNCHRONIZING
          PRIORITY</div>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import draggable from "vuedraggable";
import StaffCreate from "@/view/pages/erp/staff/StaffCreate.vue";
import StaffEdit from "@/view/pages/erp/staff/StaffEdit.vue";

export default {
  mixins: [common],
  components: {
    StaffCreate,
    StaffEdit,
    draggable,
  },
  data() {
    return {
      LoadingFlag: false,
      TableLoadingFlag: false,
      ResultFlag: false,
      reorderLoading: false,

      rows: [],
      search: "",
      CurrentYearId: 0,

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,

      selectedRecord: {},

      // Floating button props kept for logic but not used in new UI
      fab: false,
      direction: "top",
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      hover: true,
      fling: false,
      tabs: null,

      // Placeholder for table columns (needed for existing logic)
      tableColumns1: [],
      tableOptions: {},
      selected: [],
    };
  },
  computed: {
    filteredRows() {
      if (!this.search) return this.rows;
      var query = this.search.toLowerCase();
      return this.rows.filter(function (row) {
        return (
          row.MemberName.toLowerCase().includes(query) ||
          (row.StaffDesignation &&
            row.StaffDesignation.toLowerCase().includes(query)) ||
          row.MembershipId.toLowerCase().includes(query)
        );
      });
    },
  },
  methods: {
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      this.getTableRecords();
    },
    openEditPrompt(item) {
      console.log("openEditPrompt called");
      console.log({ item });
      this.selectedRecord = item;
      this.editRecordPrompt = true;
    },
    hideEditRecordPrompt() {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      this.selectedRecord = {};
      this.getTableRecords();
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getTableRecords();
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var LomCode = 1;
      console.log("LomCode=" + LomCode);

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/members";
      var upload = {
        UserInterface: 4,
        additional: {
          LomCode: LomCode,
        },
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      var thisIns = this;
      var output = "";
      var records = "";
      var successTxt = "";
      var errorTxt = "";
      var flag = 0;

      this.rows = [];
      this.ResultFlag = false;
      this.LoadingFlag = true;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ResultFlag = true;
          thisIns.LoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);

          if (flag == 1) {
            thisIns.rows = records;
            if (response.data.table_content) {
              thisIns.tableColumns1 = response.data.table_content.TableHeader;
              thisIns.tableOptions = response.data.table_content.TableOptions;
            }
            thisIns.toast("success", "Staff records loaded successfully.");
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.toast("error", error.message || "Failed to fetch records.");
          thisIns.ResultFlag = true;
          thisIns.LoadingFlag = false;
        });
    },
    changeStatus(tr) {
      console.log("changeStatus is called");
      var MemberId = tr.MemberId;
      console.log({ tr });
      console.log({ MemberId });

      if (MemberId) {
        var Status = tr.ActiveStatus ? 1 : 0;
        console.log({ Status });

        this.toast("warning", "Updating status...");

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/status-update";
        var upload = {
          UserInterface: 1,
          MemberId: MemberId,
          Status: Status,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
        );

        var thisIns = this;
        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));
            if (response.data.flag == 1) {
              thisIns.toast("success", response.data.output);
              thisIns.getTableRecords();
            } else {
              thisIns.toast("error", response.data.output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error.message);
          });
      }
    },
    onDragEnd() {
      console.log("onDragEnd is called");
      this.updateStaffOrder();
    },
    updateStaffOrder() {
      console.log("updateStaffOrder is called");
      this.reorderLoading = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/members/reorder-staff";

      var MemberId = this.rows.map(function (item) {
        return item.MemberId;
      });

      var upload = {
        MemberId: MemberId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      var thisIns = this;
      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));
          thisIns.reorderLoading = false;
          if (response.data.flag == 1) {
            thisIns.toast("success", "Display order updated successfully.");
          } else {
            thisIns.toast("error", response.data.output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.reorderLoading = false;
          thisIns.toast("error", error.message || "Failed to update order.");
        });
    },
    previewData(item, e) {
      console.log("previewData called");
      console.log({ item });
    },
    editAlert(item, e) {
      console.log("editAlert called");
      console.log({ item });
    },
    getActiveStatusColor(status) {
      if (!status) return "grey";
      var s = status.toLowerCase();
      if (s === "active") return "#56BDA3"; // Seaform
      if (s === "inactive") return "#FF5252";
      if (s === "pending") return "#EDBE38"; // Gold
      return "#3A67B1"; // Navy
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style>
/* Robust Global Style (LDMT Inspired) */
.premium-header-card .header-bubbles .bubble {
  position: absolute !important;
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 50% !important;
  animation: float-jci 18s infinite ease-in-out !important;
  -webkit-animation: float-jci 18s infinite ease-in-out !important;
}

.premium-header-card .header-bubbles .b-1 {
  width: 180px;
  height: 180px;
  left: 10%;
  top: 15%;
  animation-delay: 0s;
}

.premium-header-card .header-bubbles .b-2 {
  width: 300px;
  height: 300px;
  right: 5%;
  top: -10%;
  animation-delay: 2s;
}

.premium-header-card .header-bubbles .b-3 {
  width: 120px;
  height: 120px;
  left: 35%;
  bottom: 10%;
  animation-delay: 4s;
}

.premium-header-card .header-bubbles .b-4 {
  width: 220px;
  height: 220px;
  right: 25%;
  bottom: -5%;
  animation-delay: 1s;
}

.premium-header-card .header-bubbles .b-5 {
  width: 90px;
  height: 90px;
  left: 3%;
  bottom: 35%;
  animation-delay: 3s;
}

@keyframes float-jci {

  0%,
  100% {
    transform: translateY(0) scale(1) rotate(0deg);
  }

  50% {
    transform: translateY(-50px) scale(1.1) rotate(10deg);
  }
}

@-webkit-keyframes float-jci {

  0%,
  100% {
    -webkit-transform: translateY(0) scale(1) rotate(0deg);
  }

  50% {
    -webkit-transform: translateY(-50px) scale(1.1) rotate(10deg);
  }
}

.shadow-premium {
  box-shadow: 0 15px 45px rgba(58, 103, 177, 0.12) !important;
}

.hover-card-row {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
}

.hover-card-row:hover {
  transform: translateY(-5px) !important;
  border-color: #3A67B1 !important;
  box-shadow: 0 20px 50px rgba(58, 103, 177, 0.18) !important;
}

.action-btn-glow:hover {
  transform: scale(1.1) rotate(5deg) !important;
  box-shadow: 0 0 25px rgba(255, 255, 255, 0.4) !important;
}

.action-btn-elevate {
  transition: all 0.3s ease !important;
}

.action-btn-elevate:hover {
  transform: scale(1.25) translateY(-3px) !important;
  filter: brightness(1.1);
}

.flip-list-move {
  transition: transform 0.7s !important;
}

/* Enhanced Drag and Drop UI */
.drag-handle {
  cursor: grab !important;
  transition: color 0.3s ease !important;
}

.drag-handle:active {
  cursor: grabbing !important;
}

.drag-handle:hover {
  color: #0097D7 !important;
}

.chosen-row {
  opacity: 0.8 !important;
  transform: scale(1.02) !important;
  box-shadow: 0 25px 60px rgba(58, 103, 177, 0.25) !important;
  background: #ffffff !important;
  z-index: 99 !important;
}

.drag-row {
  opacity: 0.7 !important;
  background: #f8fafc !important;
  border: 2px solid #3A67B1 !important;
}

.ghost-row {
  opacity: 0.2 !important;
  background: #3A67B1 !important;
  border: 2px dashed #3A67B1 !important;
  transform: scale(0.98);
  box-shadow: inset 0 0 20px rgba(58, 103, 177, 0.1) !important;
}

.staff-record-row-card {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-top: 3px solid #3A67B1 !important;
}

.premium-search-input .v-input__control .v-input__slot {
  background: #f8fafc !important;
  border: 2px solid #e2e8f0 !important;
  padding: 12px 20px !important;
  transition: all 0.4s ease !important;
}

.premium-search-input.v-input--is-focused .v-input__slot {
  border-color: #3A67B1 !important;
  box-shadow: 0 0 0 5px rgba(58, 103, 177, 0.15) !important;
  background: #ffffff !important;
}

.profile-ring {
  border: 3px solid rgba(255, 255, 255, 0.3) !important;
}

/* Custom Scrollbar for modern look */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
  border: 3px solid #f1f5f9;
}

::-webkit-scrollbar-thumb:hover {
  background: #3A67B1;
}
</style>